import { Modal, Button, Badge } from './ui';

export interface AiFinding { severity: 'info' | 'warning' | 'critical'; title: string; detail: string }
export interface AiAnalysis { health: 'good' | 'attention' | 'critical'; summary: string; findings: AiFinding[]; recommendations: string[] }
export interface AiResult {
  analysis: AiAnalysis;
  model: string;
  tokens: number;
  // Mês fechado: análise vem do cache (ai_analyses) sem reprocessar
  cached?: boolean;
  generated_at?: string;
}

/** Modal padrão dos resultados das análises por IA (delivery, audiência, reports). */
export function AiInsightsModal({ open, onClose, title, result }: { open: boolean; onClose: () => void; title: string; result: AiResult | null }) {
  return (
    <Modal open={open} onClose={onClose} title={title || '✨ AI Insights'}
      footer={<Button variant="outline" onClick={onClose}>Close</Button>}>
      {result && (
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Badge tone={result.analysis.health === 'good' ? 'green' : result.analysis.health === 'attention' ? 'amber' : 'red'}>
              {result.analysis.health === 'good' ? 'SAUDÁVEL' : result.analysis.health === 'attention' ? 'ATENÇÃO' : 'CRÍTICO'}
            </Badge>
            <span className="text-xs text-slate-400">
              {result.model} · {result.tokens.toLocaleString()} tokens
              {result.cached && result.generated_at ? ` · cache de ${new Date(result.generated_at).toLocaleString()}` : ''}
            </span>
          </div>
          <p className="text-sm text-slate-700">{result.analysis.summary}</p>
          {(result.analysis.findings || []).length > 0 && (
            <div className="space-y-2">
              <div className="text-xs font-semibold text-slate-500 uppercase">Findings</div>
              {result.analysis.findings.map((f, i) => (
                <div key={i} className={`rounded-lg border px-3 py-2 text-sm ${f.severity === 'critical' ? 'border-rose-200 bg-rose-50' : f.severity === 'warning' ? 'border-amber-200 bg-amber-50' : 'border-border bg-surface-muted'}`}>
                  <div className={`font-semibold ${f.severity === 'critical' ? 'text-rose-700' : f.severity === 'warning' ? 'text-amber-700' : 'text-ink-900'}`}>{f.title}</div>
                  <div className="text-slate-600 text-xs mt-0.5">{f.detail}</div>
                </div>
              ))}
            </div>
          )}
          {(result.analysis.recommendations || []).length > 0 && (
            <div>
              <div className="text-xs font-semibold text-slate-500 uppercase mb-1">Recomendações</div>
              <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
                {result.analysis.recommendations.map((r, i) => <li key={i}>{r}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
}
